<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.awfTitle" style="width: 140px;" size="small " placeholder="请输入标题"
                        clearable></el-input>
                    <el-input v-model="formDatas.awfMobile" style="width: 140px;" size="small " placeholder="请输入手机号"
                        clearable></el-input>
                    <el-select size="small" v-model="formDatas.awfStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px">
                        <el-option label="已处理" :value="2" key="2"></el-option>
                        <el-option label="待处理" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <!-- <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="small" style="margin-right: 20px"
                        @click="BoxOpen">新建微信工具反馈</el-button>
                </el-row>
            </div> -->
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="awfId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-dialog :title="edit ? '编辑微信工具反馈' : '新增微信工具反馈'" :visible.sync="dialog" width="70%" top="8vh">
                <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:65vh">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="标题" prop="awfTitle">
                            <el-input v-model="form.awfTitle" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="具体描述" prop="awfDes">
                            <el-input v-model="form.awfDes" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>

                        <el-form-item label="微信wxid" prop="awfWxid">
                            <el-input v-model="form.awfWxid" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="微信手机号" prop="awfMobile">
                            <el-input v-model="form.awfMobile" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="微信昵称" prop="awfNickname">
                            <el-input v-model="form.awfNickname" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="图片" prop="awfImage">
                            <my-upload3 ref="Imgupload" @fileChange="ImgChange" :filearr="ImgfileList" :limit="1"
                                style="margin: 10px 5px 5px">
                            </my-upload3>
                            <!-- <el-input disabled v-model="form.awfImage" style="width: 50%" placeholder="请输入"></el-input> -->
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="SureBtn">确 定</el-button>
                </span>
            </el-dialog>
            <!--处理 -->
            <el-dialog title="处理" :visible.sync="JLdialog" width="70%" top="8vh">
                <el-form ref="formCl" :model="formCl" label-position="top" :rules="rules" style="height: 45vh">
                    <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
                        <el-form-item label="处理描述" prop="awfReply">
                            <el-input 
                                type="textarea"
                                :rows="4"
                                v-model="formCl.awfReply" 
                                style="width: 50%;" 
                                placeholder="请输入">
                            </el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="JLhandleClose">取 消</el-button>
                    <el-button type="primary" @click="JLSureBtn">确 定</el-button>
                </span>
            </el-dialog>
        </div>

    </div>
</template>

<script>
let Base64 = require("js-base64").Base64;
import {
    addAjWechatFeedback, deleteAjWechatFeedback, getIvJobChannelList, updateAjWechatFeedback, getAjWechatFeedbackList,
    updateAjWechatFeedbackReply, getIvUserList, 

} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            ImgfileList: [],
            getIvUserList_data: [],
            formBelong: {},

            JLdialog: false,
            formCl: {
                awfReply: '',
                awfId: '',
            },
            education: '',
            getIvJobChannelList_data: [],
            postForm: {

            },
            userarr: [],
            level_Four: [],
            level_Three: [],
            key: 'awfId',
            dialog: false,
            edit: false,
            form: {
                awfTitle: '',
                awfDes: '',
                awfWxid: '',
                awfNickname: '',
                awfMobile: '',
                awfImage: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "awfTitle",
                    key: "awfTitle",
                    title: "标题",
                    width: 140,
                    align: "center",
                    edit: false,
                    fixed: 'left',
                },
                {
                    field: "awfDes",
                    key: "awfDes",
                    fixed: 'left',
                    title: "具体描述",
                    // width: 130,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "awfWxid",
                    key: "awfWxid",
                    title: "微信wxid",
                    width: 160,
                    align: "center",
                    edit: false,
                },
                {
                    field: "awfMobile",
                    key: "awfMobile",
                    title: "微信手机号",
                    width: 110,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "awfNickname",
                    key: "awfNickname",
                    title: "微信昵称",
                    width: 100,
                    align: "center",
                    // edit: true,
                },

                {
                    field: "awfImage",
                    key: "awfImage",
                    title: "图片",
                    width: 100,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.awfImage ? <el-image ref="scrImg" id="scrimg" src={row.awfImage.split(',')[0]} alt="" fit="fill" style="width: 50px;height: 50px;"
                                        previewSrcList={row.awfImage.split(',')}></el-image> : <span></span>
                                }

                            </span>
                        );
                    },
                },
                {
                    field: "awfReply",
                    key: "awfReply",
                    title: "处理描述",
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "awfStatus",
                    key: "awfStatus",
                    title: "状态",
                    width: 80,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.awfStatus == 1 ? <el-tag type='danger'>待处理</el-tag> : <el-tag type='success'>已处理</el-tag>}

                            </span>
                        );
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.updataJl(row)}
                                    >
                                        处理
                                    </el-button>
                                }
                                {
                                    /* <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.handleEdit(row)}
                                    >
                                        编辑
                                    </el-button> */
                                }
                                {

                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        删除
                                    </el-button>
                                }




                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                awfTitle: "",
                awfDes: "",
                awfStatus: "",
                awfMobile: "",

                currentPage: 1,
                pageSize: 10,
            },
            postid: "",
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.postid = localStorage.getItem("iuPost");
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
        this.getPost('industry')
        getIvJobChannelList().then((res) => {
            this.getIvJobChannelList_data = res.data;
        });

    },
    mounted() { },
    methods: {
        
        handleBelong(row) {
            this.formBelong.awfId = row.awfId
            getIvUserList({ iuJoinInterview: 2 }).then((res) => {
                this.getIvUserList_data = res.data;
                this.BelongDialog = true;
            });
        },
        updataJl(id) {
            this.formCl.awfId = id.awfId;
            this.JLdialog = true;
        },
        JLhandleClose() {
            this.JLdialog = false;
            this.formCl = {};

        },
        JLSureBtn() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjWechatFeedbackReply(this.formCl).then((res) => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                            this.JLhandleClose();
                            this.getList();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        ImgChange(file) {
            console.log(file);
            if (this.form.awfImage && this.form.awfImage.length > 0) {
                this.form.awfImage.push(...file)

            } else {
                this.$set(this.form, 'awfImage', file)
            }
            file.forEach((item, index) => {
                const s = {
                    url: item,
                    name: item,
                }
                this.$set(this.ImgfileList, index, s)
            })
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        getPost(key) {
            const userpost = JSON.parse(sessionStorage.getItem('userPost')) || [];
            userpost.forEach((item, index) => {
                if (item.nsaMenuKey == key) {
                    this.postForm[item.nsaFuncKey] = item.nsaFuncLabel
                }
            })
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjWechatFeedback({ awfId: row.awfId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                this.form.awfImage = data.awfImage.split(',')
                console.log(this.form.awfImage);
                if (data.awfImage.length > 0) {
                    this.form.awfImage.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.ImgfileList, index, img)
                    })

                }

            });
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        var newForm = JSON.parse(JSON.stringify(this.form));
                        newForm.awfImage = newForm.awfImage.length > 0 ? newForm.awfImage.filter(item => typeof item === 'string').join(',') : '';
                        addAjWechatFeedback(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        var newForm = JSON.parse(JSON.stringify(this.form));
                        newForm.awfImage = newForm.awfImage.length > 0 ? newForm.awfImage.filter(item => typeof item === 'string').join(',') : '';
                        updateAjWechatFeedback(newForm).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            setTimeout(() => {
                this.$refs.Imgupload.fileAllRemove();
                this.ImgfileList = [];
            }, 10);
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.awfId = row.awfId
                    //console.log(jsonObj);
                    updateAjWechatFeedback(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // //console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        //console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(index, 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            //console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjWechatFeedbackList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjWechatFeedbackList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjWechatFeedbackList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>